import * as React from 'react';
import { Flex } from 'core/ui';

export default function MessageControl({ message }: { message: string; }): React.ReactNode {
	return <Flex.Vertical>
		<Flex.Item style={{ backgroundColor: '#000000' }} size='60px'> </Flex.Item>
		<Flex.Item style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} size='*'>
			<h1 className='font-bold' style={{ color: 'black', fontSize: 'xxx-large' }}>
				{message}
			</h1>

		</Flex.Item>
		<Flex.Item style={{ backgroundColor: '#000000' }} size='60px'> </Flex.Item>
	</Flex.Vertical>;
}
